import React, { useEffect } from "react";
import "./loyalty-reward.scss";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useGetRewardHistory } from 'hooks/useGetRewardHistory';

const LoyaltyReward = ({ lmRewardData }) => {
  const isUserLoggedIn = useSelector(({ user }) => user.isUserLoggedIn);

  const { prefetchRewardHistory } = useGetRewardHistory(lmRewardData?.lm_reward_id, false);

  useEffect(() => {
    if (!isUserLoggedIn || !lmRewardData?.lm_reward_id) return;
    prefetchRewardHistory();
  }, [isUserLoggedIn, lmRewardData?.lm_reward_id, prefetchRewardHistory]);

  return (
    <>
      <div className="loyalty-reward-main-wrap">
        <div className="loyalty-reward-box">
          <div className="loyalty-reward-img">
            <img src={lmRewardData?.image_url} alt="product_image" />
          </div>
          <div className="loyalty-reward-content-wrapper">
            <div className="loyalty-reward-subtitle">
              {lmRewardData?.RewardTitle}
            </div>
            <div className="loyalty-reward-title-btn">
              <div className="loyalty-reward-title">{lmRewardData?.title}</div>
              {lmRewardData?.PointsBasedRewardPointsToDollarInfo ? (
                <div className="loyalty-reward-point-btn">
                  <span>
                    {lmRewardData?.PointsBasedRewardPointsToDollarInfo}
                  </span>
                </div>
              ) : null}
            </div>
            <div className="loyalty-reward-range-bar">
              <div className="loyalty-reward-point">
                <span>{lmRewardData?.PurchasedAmountString}</span>
                <span className="point-title">Points Balance</span>
              </div>
              <div className="reward-btn-wrapper">
                <div className="reward-btn">
                  <Link
                    to={isUserLoggedIn ? "/rewardsdetails" : "/login"}
                    state={{
                      lmRewardId: lmRewardData?.lm_reward_id,
                      isPointBased: lmRewardData?.is_points_based,
                      lmRewardData: lmRewardData,
                    }}
                  >
                    View Details
                  </Link>
                </div>
                {isUserLoggedIn &&
                  lmRewardData?.is_points_based &&
                  lmRewardData?.IsItQualifiedforReward && (
                    <div className="reward-btn redeem-btn">
                      <Link
                        to="/rewardsdetails"
                        state={{
                          lmRewardId: lmRewardData?.lm_reward_id,
                          Redeem: true,
                          isPointBased: lmRewardData?.is_points_based,
                          lmRewardData: lmRewardData,
                        }}
                      >
                        Redeem
                      </Link>
                    </div>
                  )}
                {isUserLoggedIn &&
                  lmRewardData?.is_points_based &&
                  lmRewardData?.EnableShowPointsExpiryHistory && (
                    <div className='reward-btn redeem-btn bg-primary'>
                      <Link
                        to='/rewards-history'
                        state={{
                          lmRewardId: lmRewardData?.lm_reward_id,
                          isPointBased: lmRewardData?.is_points_based,
                          lmRewardData: lmRewardData,
                        }}
                      >
                        {lmRewardData?.PointsExpiryHistoryButtonText || 'View History'}
                      </Link>
                    </div>
                  )}
              </div>
            </div>
            {lmRewardData?.NoOfPointsExpireString ? (
              <div className='loyalty-reward-points-expiring'>
                {lmRewardData?.NoOfPointsExpireString}
              </div>
            ) : null}
            {lmRewardData?.RewardsProgramPolicyUrl ? (
              <div className='loyalty-reward-policy'>
                <a
                  className='loyalty-reward-policy-link'
                  href={lmRewardData?.RewardsProgramPolicyUrl}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  {lmRewardData?.RewardsProgramPolicyTitle}
                </a>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};

export default LoyaltyReward;
